export default __webpack_public_path__ + "static/media/background_food.64bcefc0.svg";